<template>
  <div>
    <ActionsMenu
      placement="bottom"
      :actions="actions"
      @add-coverage-area="handleAddCoverageArea"
      @download="handleDownload"
      @template="downloadTemplate"
      @upload="uploadModal = true"
    >
      <template #trigger>
        <Button
          icon="fa-solid fa-angle-down"
          text="Actions"
          icon-position="right"
          data-cy="task_actions"
        />
      </template>
    </ActionsMenu>
    <CoverageAreaUploadModal
      v-if="uploadModal"
      @hide-modal="uploadModal = false"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

import ActionsMenu from "@/components/ActionsMenu.vue";
import Button from "@/components/Button.vue";
import CoverageAreaUploadModal from "@/CompanyCoverageAreas/CoverageAreaUploadModal.vue";

const uploadModal = ref(false);

const actions = computed(() => {
  return [
    {
      label: "Add Coverage Area",
      icon: "fa-solid fa-plus",
      eventName: "add-coverage-area"
    },
    {
      label: "Download Coverage Areas",
      icon: "fa-solid fa-download",
      eventName: "download"
    },
    {
      label: "Download Template",
      icon: "fa-solid fa-file-excel",
      eventName: "template"
    },
    {
      label: "Upload Coverage Areas",
      icon: "fa-solid fa-upload",
      eventName: "upload"
    }
  ];
});

const emit = defineEmits(["download", "add-coverage-area"]);

function handleAddCoverageArea() {
  emit("add-coverage-area");
}

function handleDownload() {
  emit("download");
}
function downloadTemplate() {
  window.location.pathname = "/admin/v4/coverage_areas/template.xlsx";
}
</script>

<style scoped></style>
